/**
 * Centralized limit type definitions and styling constants
 * Used across all limit-related components for consistency
 */

export const LIMIT_TYPE_LABELS = {
  // Frontend keys (new API format)
  responses: 'Responses',
  bugs: 'Bug Reports',
  features: 'Feature Requests',
  reviews: 'Reviews',
  programs: 'Programs',
  widgets: 'Widgets',
  webhooks: 'Webhooks',

  // Backend keys (legacy format for backward compatibility)
  lifetime_responses: 'Responses',
  lifetime_bugs: 'Bug Reports',
  lifetime_features: 'Feature Requests',
  lifetime_reviews: 'Reviews',
} as const;

export type LimitType = keyof typeof LIMIT_TYPE_LABELS;

/**
 * Get the display label for a limit type
 * @param limitType - The limit type key
 * @returns The human-readable label
 */
export function getLimitLabel(limitType: string): string {
  return LIMIT_TYPE_LABELS[limitType as LimitType] || limitType;
}

/**
 * Standardized upgrade button gradient styling
 * Used across all CTAs and upgrade buttons
 */
export const UPGRADE_BUTTON_GRADIENT =
  "bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white";

/**
 * Progressive dismiss durations based on severity
 */
export const DISMISS_DURATION = {
  info: 7 * 24 * 60 * 60 * 1000,      // 7 days for 50-74%
  warning: 7 * 24 * 60 * 60 * 1000,   // 7 days for 75-89%
  urgent: 3 * 24 * 60 * 60 * 1000,    // 3 days for 90-99%
  critical: 0,                         // Can't dismiss at 100%
} as const;
